// extracted by mini-css-extract-plugin
export default {"stepPointerBlock":"style_stepPointerBlock__UjdLM","active":"style_active__KmTOU"};